import { useTranslation } from "react-i18next";
import classNames from "classnames";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import StopOutlinedIcon from "@mui/icons-material/StopOutlined";
import styles from "./styles.module.scss";
import Modal from "../../../components/common/Modal";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../components/common/PrimaryButton";
import Spinner from "../../../components/common/Spinner";

export type TToggleAction = "start" | "stop";

interface IToggleConfirmModalProps {
  action: TToggleAction | null;
  saving: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

/** Confirms starting or stopping auto cashout; both move real money. */
const ToggleConfirmModal = ({
  action,
  saving,
  handleClose,
  handleConfirm,
}: IToggleConfirmModalProps) => {
  const { t } = useTranslation();
  const isStop = action === "stop";

  return (
    <Modal
      visible={!!action}
      onCancel={() => !saving && handleClose()}
      customModalClassName={styles.modal}>
      <div className={styles.container}>
        <span
          className={classNames(styles.icon, {
            [styles.iconDanger]: isStop,
          })}>
          {isStop ? <StopOutlinedIcon /> : <PlayArrowOutlinedIcon />}
        </span>
        <h1 className={styles.title}>
          {isStop
            ? t("lbl_auto_cashout_settings_stop_title")
            : t("lbl_auto_cashout_settings_start_title")}
        </h1>
        <p className={styles.message}>
          {isStop
            ? t("lbl_auto_cashout_settings_stop_message")
            : t("lbl_auto_cashout_settings_start_message")}
        </p>

        <div className={styles.actions}>
          <PrimaryButton
            buttonType={
              isStop ? PrimaryButtonType.DANGER : PrimaryButtonType.DEFAULT
            }
            disabled={saving}
            onClick={handleConfirm}>
            {saving ? (
              <Spinner />
            ) : isStop ? (
              t("lbl_auto_cashout_settings_stop_confirm")
            ) : (
              t("lbl_auto_cashout_settings_start_confirm")
            )}
          </PrimaryButton>
          <button
            type="button"
            className={styles.cancelButton}
            disabled={saving}
            onClick={handleClose}>
            {t("lbl_cancel")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ToggleConfirmModal;
